/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * テキスト配置
 * @export
 */
export const TextAlignment = {
  Left: 'left',
  Center: 'center',
  Right: 'right'
} as const
export type TextAlignment = typeof TextAlignment[keyof typeof TextAlignment]

export function TextAlignmentFromJSON(json: any): TextAlignment {
  return TextAlignmentFromJSONTyped(json, false)
}

export function TextAlignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextAlignment {
  return json as TextAlignment
}

export function TextAlignmentToJSON(value?: TextAlignment | null): any {
  return value as any
}
